// src/Pages/Home.js
import React, { useState } from "react";
import ProductList from "../Components/ProductList";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/autoplay";
import { Autoplay } from "swiper/modules";
import { homeCategories } from "../data/homeCategories";

const bannerImages = [
  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRTA6nJTx4CoG7Huk5ZOg-QO-KvuHabYq76jw&s",
  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRlGejzYGVdlIXlzdPyMd1oP_8rLf9l85xrbQ&s",
];

export default function Home() {
  const [selectedCategory, setSelectedCategory] = useState(() => {
    return homeCategories.find((cat) => cat.name === "Hotel");
  });
  const [selectedSubCategory, setSelectedSubCategory] = useState(() => {
    const hotelCategory = homeCategories.find((cat) => cat.name === "Hotel");
    return (
      hotelCategory?.subcategories?.find((sub) => sub.name === "Room Service") ||
      null
    );
  });
  const [selectedSubSubCategory, setSelectedSubSubCategory] = useState(null);

  return (
    <div className="space-y-10">
      {/* ✅ Top banner slider (90% screen width) */}
      <div className="w-[90vw] mx-auto rounded-2xl overflow-hidden shadow-xl">
        <Swiper
          modules={[Autoplay]}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          loop
          className="rounded-2xl"
        >
          {bannerImages.map((img, index) => (
            <SwiperSlide key={index}>
              <div className="relative w-full h-[300px] sm:h-[400px] md:h-[500px] lg:h-[600px]">
                <img
                  src={img}
                  alt={`banner-${index}`}
                  className="w-full h-full"
                />
                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>

                {/* Banner Text */}
                <div className="absolute bottom-6 left-6 sm:left-12 text-white space-y-2">
                  <h2 className="text-2xl sm:text-4xl font-bold drop-shadow-lg">
                    Welcome to Our Platform
                  </h2>
                  <p className="text-sm sm:text-lg font-medium drop-shadow-md">
                    Discover services, products, and more
                  </p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* ✅ Main Content Wrapper (90% width too, for alignment) */}
   <div className="w-[95vw] mx-auto space-y-2">
  {/* Categories Section */}
  <section className="bg-white rounded-2xl shadow-lg p-6">
    <h2 className="text-2xl font-bold mb-6 text-gray-900">Categories</h2>
    <div className="flex gap-6 overflow-x-auto py-4 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">
      {homeCategories.map((cat) => (
        <div
          key={cat.name}
          onClick={() => {
            setSelectedCategory(cat);
            setSelectedSubCategory(null);
            setSelectedSubSubCategory(null);
          }}
          className={`flex-shrink-0 w-36 cursor-pointer rounded-xl shadow-md transition transform hover:scale-105 hover:shadow-lg border-2 ${
            selectedCategory?.name === cat.name
              ? "border-indigo-500"
              : "border-transparent"
          }`}
        >
          <div className="aspect-square w-full">
            <img
              src={cat.image}
              alt={cat.name}
              className="w-full h-full object-cover rounded-t-xl"
            />
          </div>
          <div className="p-3 text-center text-base font-semibold text-gray-800 bg-gray-50 rounded-b-xl">
            {cat.name}
          </div>
        </div>
      ))}
    </div>
  </section>

  {/* Subcategories Section */}
  {selectedCategory?.subcategories?.length > 0 && (
    <section className="bg-white rounded-2xl shadow-lg p-6">
      <h2 className="text-xl font-semibold mb-5 text-gray-900">Subcategories</h2>
      <div className="flex gap-5 overflow-x-auto py-3 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">
        {selectedCategory.subcategories.map((sub) => (
          <div
            key={sub.name}
            onClick={() => {
              setSelectedSubCategory(sub);
              setSelectedSubSubCategory(null);
            }}
            className={`flex-shrink-0 w-28 cursor-pointer rounded-lg shadow transition transform hover:scale-105 hover:shadow-md border-2 ${
              selectedSubCategory?.name === sub.name
                ? "border-indigo-400"
                : "border-transparent"
            }`}
          >
            <div className="aspect-square w-full">
              <img
                src={sub.image}
                alt={sub.name}
                className="w-full h-full object-cover rounded-t-lg"
              />
            </div>
            <div className="p-2 text-center text-sm font-medium text-gray-700 bg-gray-50 rounded-b-lg">
              {sub.name}
            </div>
          </div>
        ))}
      </div>
    </section>
  )}

  {/* Sub-subcategories Section */}
  {selectedSubCategory?.subcategories?.length > 0 && (
    <section className="bg-white rounded-2xl shadow-lg p-6">
      <h2 className="text-lg font-semibold mb-4 text-gray-900">
        Sub-subcategories
      </h2>
      <div className="flex gap-4 overflow-x-auto py-3 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">
        {selectedSubCategory.subcategories.map((subsub) => (
          <div
            key={subsub.name}
            onClick={() => setSelectedSubSubCategory(subsub)}
            className={`flex-shrink-0 w-20 cursor-pointer rounded-md shadow transition transform hover:scale-105 border-2 ${
              selectedSubSubCategory?.name === subsub.name
                ? "border-indigo-300"
                : "border-transparent"
            }`}
          >
            <div className="aspect-square w-full">
              <img
                src={subsub.image}
                alt={subsub.name}
                className="w-full h-full object-cover rounded-t-md"
              />
            </div>
            <div className="p-1 text-center text-xs font-medium text-gray-700 bg-gray-50 rounded-b-md">
              {subsub.name}
            </div>
          </div>
        ))}
      </div>
    </section>
  )}

  {/* Products Section */}
  {(selectedSubSubCategory?.products?.length > 0 ||
    selectedSubCategory?.products?.length > 0 ||
    selectedCategory?.products?.length > 0) && (
    <section className="bg-white rounded-2xl shadow-lg p-6">
      <h2 className="text-xl font-semibold mb-5 text-gray-900">Products</h2>
      <ProductList
        products={
          selectedSubSubCategory?.products ||
          selectedSubCategory?.products ||
          selectedCategory?.products
        }
        isCategory={false}
      />
    </section>
  )}
</div>
    </div>
  );
}